<template>
  <div class="d-flex align-center mb-4">
    <v-btn
      icon
      class="mr-2"
      @click="$emit('back')"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <h1 class="text-h4">{{ title }}</h1>
    <v-spacer></v-spacer>
    <v-btn
      color="secondary"
      class="mr-3"
      @click="$emit('toggle-preview')"
    >
      <v-icon left>mdi-eye</v-icon>
      {{ previewActive ? 'Edit Mode' : 'Preview' }}
    </v-btn>
    <v-btn
      color="primary"
      @click="$emit('add-section')"
    >
      <v-icon left>mdi-plus</v-icon>
      Add Section
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'TemplateHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    previewActive: {
      type: Boolean,
      default: false
    }
  }
}
</script>